import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import LoginModal from './login-modal.vue';
import '../../../css/pages/login-form/login-form.scss';

const MOUNT_ID = 'global-login-modal-vue';

let loginModalApp: App<Element> | null = null;
let loginModalInstance: { open: () => void } | null = null;
let currentMountEl: HTMLElement | null = null;
let loginTriggersInitialized = false;

function resolveMountRoot(root?: ParentNode): HTMLElement | null {
  const fromDom = root
    ? root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID)
    : document.getElementById(MOUNT_ID);

  if (fromDom) return fromDom;

  const dynamicMountEl = document.createElement('div');
  dynamicMountEl.id = MOUNT_ID;
  document.body.appendChild(dynamicMountEl);
  return dynamicMountEl;
}

function mountLoginModal(root?: ParentNode): void {
  const mountEl = resolveMountRoot(root);
  if (!mountEl) return;

  if (loginModalApp && currentMountEl) {
    loginModalApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(LoginModal);
  app.use(AntDesignVue);
  const instance = app.mount(mountEl) as unknown as { open: () => void };

  loginModalApp = app;
  loginModalInstance = instance;
  currentMountEl = mountEl;
}

export function openLoginModal(): void {
  if (!loginModalApp || !loginModalInstance) {
    mountLoginModal();
  }

  loginModalInstance?.open();
}

export function initLoginModal(root?: ParentNode): void {
  mountLoginModal(root);
}

export function initLoginModalTriggers(): void {
  if (loginTriggersInitialized) return;
  loginTriggersInitialized = true;

  initLoginModal();

  document.addEventListener('click', (event: Event) => {
    const target = event.target as HTMLElement | null;
    const trigger = target?.closest<HTMLElement>('[data-login-open-modal]');
    if (!trigger) return;

    event.preventDefault();
    openLoginModal();
  });
}
